module.exports = __webpack_public_path__ + "img/20180815_150347_077.00cc58b5.jpg";